import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Paper, Grid, useTheme, Typography, CircularProgress, Select, MenuItem, Stack, Switch, alpha, Tabs, Tab, Tooltip, TextField, FormControl, InputLabel } from "@mui/material";
import AxionControls from "../../../components/controls/AxionControls";
import GridDateTimePicker from "../../home/components/GridDateTimePicker";
import messages from "../messages";
import { useMsal, useAccount } from "@azure/msal-react";
import { tokens } from "../../../assets/theme";
import { FormattedMessage, useIntl } from "react-intl";
import { postNewPO, updatePO, postNewBlock, getItemMachinesForItem, getItemMachinesForMachineName } from "../../../fetchers/productionPlan";
import { getProductionOrderHistoryByTool, getProductionOrderOee } from "../../../fetchers/productionOrder";
import { ReplanMachine2, ReCalculateEndTimeForNewOrder } from "./planningFunctions";
import { fetchProductionItems } from "../../../fetchers/productionItems";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { pushErrorMessage, pushNotification } from "../../../utils/notifications";
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ProductionPlanEditBlockers from "./productionPlanEditBlockers";
import dayjs from "dayjs";
import PropTypes from 'prop-types';
import { styled } from "@mui/material/styles";
import Popup from "../../../components/Popup";
import { getBlockers } from "../../../fetchers/productionPlan";
import { useQuery } from "@tanstack/react-query";


export default function PlanNewPODialog(props) {

    //#### Hårdkodningar
    const gapInMinutes = 120;
    const defaultOee = 0.8;
    //####


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { formatMessage } = useIntl();
    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);

    const [quantity, setQuantity] = React.useState(0);
    const [startTime, setStartTime] = React.useState(props.addObjAtTime ?? new Date());
    const [productId, setProductId] = React.useState(null);
    const [machineId, setMachineId] = React.useState(props?.machine?.la?.id);
    const [initialMachineId, setInitialMachineId] = React.useState(null);
    const [blockEndTime, setBlockEndTime] = React.useState(dayjs(startTime).add(2, 'hour').toDate());
    const [blockType, setBlockType] = React.useState("");
    const [buttonDisabled, setButtonDisabled] = React.useState(false);
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [showEditBlockers, setShowEditBlockers] = React.useState(false);

    const [blockTextBefore, setBlockTextBefore] = useLocalStorage("PplBlockTextBefore", "");
    const [minutesBefore, setMinutesBefore] = useLocalStorage("PplMinutesBefore", 0);
    const [addBlockBefore, setAddBlockBefore] = useLocalStorage("PplAddBlockBefore", "false");
    const [blockTextAfter, setBlockTextAfter] = useLocalStorage("PplBlockTextAfter", "");
    const [minutesAfter, setMinutesAfter] = useLocalStorage("PplMinutesAfter", 0);
    const [addBlockAfter, setAddBlockAfter] = useLocalStorage("PplAddBlockAfter", "false");
    const [tak, setTak] = React.useState(defaultOee);
    const [oeeAvg, setOeeAvg] = React.useState(null);
    const [oeeAvgCount, setOeeAvgCount] = React.useState(0);
    const [oeeHistoric, setOeeHistoric] = React.useState(null);
    const [itemMachines, setItemMachines] = React.useState([]);
    const [toolId, setToolId] = React.useState(null);
    const [stockBalance, setStockBalance] = React.useState(0);
    const [reservedBalance, setReservedBalance] = React.useState(0);
    const [idealCycleTime, setIdealCycleTime] = React.useState(60);
    const [idealTimeToEnd, setIdealTimeToEnd] = React.useState(0);
    const [calcEndTime, setCalcEndTime] = React.useState(null);
    const [speedUnitTypeId, setSpeedUnitTypeId] = React.useState(1);
    const [historicOeeFound, setHistoricOeeFound] = React.useState(false);
    const [lastArticleForTool, setLastArticleForTool] = React.useState(null);
    const [manualOee, setManualOee] = React.useState(null);
    const [oeeType, setOeeType] = React.useState("historic");
    const [showManualOeeInput, setShowManualOeeInput] = React.useState(false);
    const language = localStorage.getItem('language') || 'en';

    const isoFormat = "YYYY-MM-DDTHH:mm:ss";


    console.log("language", language);

    // let localCalcEndTime = null;
    // let localIidealTimeToEnd = null;
    // let idealRunTime = null;


    //console.log("PlanNewPODialog props:", props);
    //console.log("zzzsetSpeedUnitTypeId init:", speedUnitTypeId);

    // useEffect(() => {
    //     if (toolId != null && toolId !== "" && toolId !== undefined) {
    //         setArticleForTool(toolId);
    //     }
    // }, [toolId]);


    const blockerQuery = useQuery(
        ["blocker"],
        () => getBlockers(),
        {}
    );


    // getItemMachinesForMachineName(getMachineNameById(props?.machine?.la?.id || initialMachineId))
    const itemsForMachineQuery = useQuery(
        ["itemMachinesForMachine"],
        () => getItemMachinesForMachineName(null, companyKey),
        {}
    );

    const productionItemsQuery = useQuery(
        ["productionItems", companyKey],
        () => fetchProductionItems(companyKey),
        {}
    );


    function getDistinctItemsForMachine(data, machineName) {
        let itemsForMachineLocal = [];
        itemsForMachineLocal = data?.filter(i => i.machineName === machineName);
        let distinctItemsLocal = [];

        distinctItemsLocal = getDistinctItems(itemsForMachineLocal);

        return distinctItemsLocal;
    }

    function getDistinctItems(data) {
        let distinctItemsLocal = [];
        distinctItemsLocal = data?.reduce((accumulator, current) => {
            if (!accumulator.some(item => item.itemNo === current.itemNo)) {
                accumulator.push(current);
            }
            return accumulator;
        }, []) || [];
        return distinctItemsLocal;
    }

    const distinctItemsForMachines = useMemo(() => {

        let distinctItems = getDistinctItems(itemsForMachineQuery.data)
        return distinctItems;
    }, [itemsForMachineQuery.data]);


    const itemsForMachines = useMemo(() => {
        let result = [];

        //console.log ("itemsForMachineQuery data:", itemsForMachineQuery.data);

        if (itemsForMachineQuery === undefined || itemsForMachineQuery.data === undefined || itemsForMachineQuery.data.length === 0) {
            //If no items for machine data, show all items
            let productionItems = productionItemsQuery?.data || [];
            result = productionItems.map((item, index) => ({
                key: index, id: "a-" + item.itemNo, title: `${item.itemNo} - ${item.itemName}`,
            }));
        } else {

            //distinct items regardless of machine
            let distinctItemsLocal = getDistinctItems(itemsForMachineQuery.data);
            //items for current machine
            let distinctItemsForMachineLocal = getDistinctItemsForMachine(itemsForMachineQuery.data, getMachineNameById(machineId));

            let forMachine = distinctItemsForMachineLocal?.map((m, index) => (
                { key: index, id: "m-" + m.itemNo, title: `${m.itemNo} - ${m.itemName}` }
            )) || [];

            //console.log ("distinctItemsLocal:", distinctItemsLocal); 

            //all items regardless of machine
            let allItems = distinctItemsLocal.map((item, index) => ({
                key: index, id: "a-" + item.itemNo, title: `${item.itemNo} - ${item.itemName}`,
            }));

            result.push(...forMachine);
            if (forMachine.length > 0) {
                result.push({ key: "zzz", id: "zzz", title: "---------- ALL ITEMS ----------" });
            }
            result.push(...allItems);
        }

        return result;
    }, [itemsForMachineQuery?.data, productionItemsQuery?.data, machineId]);

    useEffect(() => {
        let resultOee = defaultOee;

        switch (oeeType) {
            case "manual":
                resultOee = manualOee;
                break;
            case "historic":
                resultOee = oeeHistoric;
                break;
            case "historic avg":
                resultOee = oeeAvg;
                break;
            case "default":
                resultOee = defaultOee;
                break;
            default:
                resultOee = defaultOee;
                break;
        }

        if (isNaN(resultOee) || resultOee === null || resultOee === undefined) {
            resultOee = defaultOee;
        }

        setTak(resultOee);

        let result = ReCalculateEndTimeForNewOrder(startTime, quantity, 0, resultOee, speedUnitTypeId, idealCycleTime);
        setIdealTimeToEnd(result.idealTimeToEnd);

    }, [oeeType, manualOee, oeeHistoric, oeeAvg, defaultOee, startTime, quantity, speedUnitTypeId, idealCycleTime]);



    function getHourAndMinutesFromMinutes(totalMinutes) {
        if (isNaN(totalMinutes) || totalMinutes === null || totalMinutes === undefined || totalMinutes <= 0) {
            return { hours: "-", minutes: "-" };
        }
        const hours = (Math.floor(totalMinutes / 60)).toFixed(0);
        const minutes = (totalMinutes % 60).toFixed(0);
        return { hours, minutes };
    }

    function formatDate(date) {
        return date ? new Date(date).toLocaleDateString('sv-SE') : "";
    }
    function formatFullTime(date) {
        return date ? new Date(date).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : "";
    }
    function xformatDateAndFullTime(date) {
        return date ? formatDate(date) + "T" + formatFullTime(date) : "";
    }
    function getMachineNameById(id) {
        const machine = props.machineQuery?.find((machine) => machine.id === id);
        return machine ? machine.machineName : "";
    }
    function getMachineIdByName(name) {
        const machine = props.machineQuery?.find((machine) => machine.machineName === name);
        return machine ? machine.id : "";
    }
    function formatDateAndFullTime(date) {
        return dayjs(date).format(isoFormat);
    }
    function isDateValid(dateStr) {
        return !isNaN(new Date(dateStr));
    }
    const handleStartTimeChange = (event) => {
        let startDate = startTime;
        if (isDateValid(event)) {
            startDate = dayjs(event).format(isoFormat);
        } else {
            console.log("!!!Invalid date:", event);
            startDate = startTime;
        }
        console.log("!!!!Start time changed:", startDate);
        setStartTime(startDate);
    }
    const handleBlockEndTimeChange = (event) => {

        let endDate = blockEndTime;
        if (isDateValid(event)) {
            endDate = dayjs(event).format(isoFormat);
        }
        console.log("!!!!End time changed:", endDate);
        setBlockEndTime(endDate);
    }

    const handleQuantityChange = (event) => {
        if (isNaN(event.target.value)) {
            event.target.value = quantity;
        } else {
            setQuantity(event.target.value);
        }
    }

    const handleOeeTypeChange = (event, newValue) => {
        const nextOeeType = event.target.value;

        setOeeType(nextOeeType);

        //console.log("OEE type changed:", nextOeeType, newValue);

        if (nextOeeType === "manual") {
            setShowManualOeeInput(true);
        } else {
            setShowManualOeeInput(false);
        }

        //####
        if (machineId !== null && machineId.length !== 0) {
            if (productId !== null && productId.length !== 0) {
                setOEEDataForMachineAndProduct(machineId, productId, itemMachines, nextOeeType, manualOee);
            } else {
                alert("Please select a product.");
            }
        } else {
            alert("Please select a machine.");
        }

    }

    const handleManualOeeChange = (event) => {
        const rawValue = event.target.value;

        //console.log("Manual OEE changed:", rawValue);

        if (rawValue === "") {
            setManualOee(null);
            setOeeType("default");
            setShowManualOeeInput(true);
            return;
        }

        if (isNaN(rawValue)) {
            return;
        }

        let value = parseFloat(rawValue);
        if (value < 0 || value > 100) {
            return;
        }

        value = value / 100;
        setManualOee(value);

        if (oeeType !== "manual") {
            setOeeType("manual");
            setShowManualOeeInput(true);
        }
    }

    const handleProductChange = (event, newValue) => {

        console.log("Product changed:", event.target, event.target.value, newValue);

        let type = newValue?.id?.startsWith("m-") ? "machine" : newValue?.id?.startsWith("a-") ? "all" : "unknown";

        //console.log("Determined product change type:", type);

        if (type === "unknown") {
            console.log("NO PRODUCT SELECTED!!!!", newValue);
            return;
        }

        //remove first two characters to get actual itemNo
        let prodId = newValue?.id ? newValue.id.substring(2) : null;
        setProductId(prodId);

        let machinesForItem = [];

        if (type === "all") {

            //console.log("Product changed 2:", event.target, event.target.value, newValue);

            //set current machine

            //get all machines
            machinesForItem = props.machineQuery || [];
            setItemMachines(machinesForItem);

            //setMachineId(machinesForItem[0]?.machineName);  //already set to current machine
            setOEEDataForMachineAndProduct(machineId, prodId, machinesForItem, oeeType, manualOee);
            let sUTI = props.machineQuery?.find((machine) => machine.machineName === getMachineNameById(machineId))?.speedUnitTypeId || 1;
            setSpeedUnitTypeId(sUTI);

        } else if (type === "machine") {

            console.log("Product changed 3:", event.target, event.target.value, newValue);

            getItemMachinesForItem(prodId, companyKey).then((machines) => {

                //Get Speedunit
                machinesForItem = machines.sort((a, b) => a.abC_Class.localeCompare(b.abC_Class));

                //get mchines not in result
                let otherMachines = props.machineQuery.filter(m => !machinesForItem.some(r => r.machineName === m.machineName));
                machinesForItem = machinesForItem.concat(otherMachines);

                //console.log("Machines for item:", machinesForItem);
                setItemMachines(machinesForItem);
                if (machineId == null || machineId.length === 0) {
                    setMachineId(machinesForItem[0]?.machineId);
                }

                if (machineId !== null && machineId.length !== 0) {
                    if (prodId !== null && prodId.length !== 0) {
                        setOEEDataForMachineAndProduct(machineId, prodId, machinesForItem, oeeType, manualOee);
                    } else {
                        //alert("Please select a product.");
                    }

                } else {
                    //alert("Please select a machine.");
                }

                let sUTI = props.machineQuery?.find((machine) => machine.machineName === machines[0]?.machineName)?.speedUnitTypeId || 1;
                setSpeedUnitTypeId(sUTI);
            }).catch((error) => {
                console.log("zzzCould not fetch item machines for product:" + prodId, error);
            });

            //clear other product selection if exists
            let otherControl = document.getElementById("AllProducts");
            if (otherControl) {
                //console.log("Clearing other product selection:", otherControl.value, otherControl);
                otherControl.value = "";
            }
        } else {
            //console.log("NO PRODUCT SELECTED!!!!", newValue);
            return;
        }

        //console.log("Product changed, about to set oee data:", machineId, prodId, machinesForItem);

        if (machineId !== undefined && machineId !== null && machineId.length !== 0) {
            if (prodId !== undefined && prodId !== null && prodId.length !== 0) {
                setOEEDataForMachineAndProduct(machineId, prodId, machinesForItem, oeeType, manualOee);
            } else {
                //alert("Please select a product.");
            }

        } else {
            //alert("Please select a machine.");
        }
    }

    const handleInitialMachineChange = (event) => {
        let machId = getMachineIdByName(event.target.value);
        setInitialMachineId(machId);
        setMachineId(machId);
    }

    const handleMachineChange = (event) => {
        let machId = getMachineIdByName(event.target.value);
        setMachineId(machId);

        let sUTI = props.machineQuery?.find((machine) => machine.machineName === event.target.value)?.speedUnitTypeId;
        setSpeedUnitTypeId(sUTI);

        setOEEDataForMachineAndProduct(machId, productId, itemMachines, oeeType, manualOee);
    }

    const setOEEDataForMachineAndProduct = (machId, prodId, machinesForItem, oeeTypeOverride, manualOeeOverride) => {

        let machName = getMachineNameById(machId);

        let selectedMachine = machinesForItem.find(m => m.machineName === machName);

        setStockBalance(selectedMachine?.stockBalance || 0);
        setReservedBalance(selectedMachine?.reservedBalance || 0);
        setToolId(selectedMachine?.toolId || null);
        setIdealCycleTime(selectedMachine?.idealCycleTime || 60);

        //console.log("zzzsetOEEDataForMachineAndProduct :", machId, prodId, selectedMachine?.stockBalance || 0, selectedMachine?.reservedBalance || 0, selectedMachine?.toolId || null, selectedMachine?.idealCycleTime || 60);

        getProductionOrderOee(machId, prodId, companyKey).then((oeeData) => {

            let ordersWithOee = oeeData ? oeeData.filter(x => x.tak !== undefined && x.tak !== null) : [];
            let lengthWithOee = ordersWithOee.length;
            let localOeeAvgCalc = ordersWithOee.length > 0 ? ordersWithOee.reduce((sum, record) => sum + (record.tak || 0), 0) / lengthWithOee / 100 : null;
            let localOeeHistoric = (oeeData && oeeData.length > 0 && oeeData[0].tak !== undefined && oeeData[0].tak !== null) ? oeeData[0].tak / 100 : null;

            setOeeHistoric(localOeeHistoric)
            setOeeAvg(localOeeAvgCalc);
            setOeeAvgCount(lengthWithOee);

            //let firstOeeData = oeeData && oeeData.length > 0 ? oeeData[0] : null;
            //let oee = (firstOeeData && firstOeeData.tak !== undefined && firstOeeData.tak !== null) ? firstOeeData.tak / 100 : defaultOee;

            let resultOee = defaultOee;
            const resolvedOeeType = oeeTypeOverride || oeeType;
            const resolvedManualOee = manualOeeOverride !== undefined ? manualOeeOverride : manualOee;

            //console.log("Resolved OEE type:", resolvedOeeType, "Manual OEE:", resolvedManualOee, "Historic OEE:", localOeeHistoric, "Avg OEE:", localOeeAvgCalc);

            switch (resolvedOeeType) {
                case "manual":
                    resultOee = resolvedManualOee;
                    break;
                case "historic":
                    resultOee = localOeeHistoric;
                    break;
                case "historic avg":
                    resultOee = localOeeAvgCalc;
                    break;
                case "default":
                    resultOee = defaultOee;
                    break;
                default:
                    resultOee = defaultOee;
                    setOeeType("default");
                    break;
            }

            if ((isNaN(resultOee) || resultOee === null || resultOee === undefined) && resolvedOeeType !== "manual") {
                resultOee = defaultOee;
                setOeeType("default");
            }

            let result = ReCalculateEndTimeForNewOrder(startTime, quantity, 0, resultOee, speedUnitTypeId, idealCycleTime);
            setIdealTimeToEnd(result.idealTimeToEnd);

            setTak(resultOee);

            if (localOeeHistoric !== null) {
                setHistoricOeeFound(true);
            } else {
                setHistoricOeeFound(false);
            }

            setArticleForTool(selectedMachine?.toolId || null);
        }
        ).catch((error) => {
            console.log("Could not fetch OEE data for product", error);
            setTak(defaultOee);
            setHistoricOeeFound(false);
        });
    }

    const setArticleForTool = (toolId) => {

        getProductionOrderHistoryByTool(toolId, companyKey).then((oeeData) => {
            //console.log("OEE data history for tool:", oeeData);
            //console.log("OEE history item for tool:", oeeData[0].itemNo);
            setLastArticleForTool(oeeData[0]?.itemNo || null);
        }
        ).catch((error) => {
            console.log("Could not fetch history by tool", error);
            setLastArticleForTool(null);
        });
    }




    const handleSnapChange = (event) => {
        props.setSnapToPrevious(event.target.checked.toString());
    }
    const handleReplanChange = (event) => {
        props.setReplanOverlaps(event.target.checked.toString());
    }
    const handleRecalculateChange = (event) => {
        props.setRecalculateAffectedOrders(event.target.checked.toString());
    }
    const handleAddBlockBeforeChange = (event) => {
        props.setAddBlockBefore(event.target.checked.toString());
    }
    const handleMinutesBeforeChange = (event) => {
        props.setMinutesBefore(event.target.value);
    }
    const handleTextBeforeChange = (event) => {
        props.setBlockTextBefore(event.target.value);
    }
    const handleTextAfterChange = (event) => {
        props.setBlockTextAfter(event.target.value);
    }
    const handleAddBlockAfterChange = (event) => {
        props.setAddBlockAfter(event.target.checked.toString());
    }
    const handleMinutesAfterChange = (event) => {
        props.setMinutesAfter(event.target.value);
    }

    const handleEditBlockers = () => {
        // Implement the logic to handle editing blockers
        //console.log("Edit blockers clicked");
        setShowEditBlockers(true);
    }

    const handleAddPO = (pType) => {


        props.setShowBackdrop(true);
        setButtonDisabled(true);

        //#################################
        //let idealCycleTime = 60;
        //let tool = "123";
        //#################################

        // Get tool for article and machine
        let tool = toolId;

        let machineData = props.machineData;
        if (machineData === undefined || machineData === null || machineData.length === 0) {
            machineData = props.plannedData[0]?.children?.filter(machine => machine.id === machineId);
        }
        let machineName = getMachineNameById(machineId);

        //console.log("ReCalculateEndTimeForNewOrder - Starttime:", startTime, "quantity:", quantity, "itemOEE:", tak, "speedUnitTypeId:", speedUnitTypeId, "idealCycleTime:", idealCycleTime);
        let result = ReCalculateEndTimeForNewOrder(startTime, quantity, 0, tak, speedUnitTypeId, idealCycleTime);
        let localCalcEndTime = result.calcEndTime;
        let localIidealTimeToEnd = result.idealTimeToEnd;
        let idealRunTime = result.idealRunTime;

        //console.log("ReCalculateEndTimeForNewOrder - Results:", localCalcEndTime, localIidealTimeToEnd, idealRunTime);

        setIdealTimeToEnd(localIidealTimeToEnd);
        setCalcEndTime(localCalcEndTime);

        //console.log("Calculated end time for new order:", localCalcEndTime, localIidealTimeToEnd, idealRunTime);
        // Prolong by weekends
        let prolongedEndTime = localCalcEndTime;
        // let prolongedEndTime = ProlongTimespanFromCapacity(startTime, calcEndTime, true, true, 0);
        // console.log("Prolonged end time for new order:", prolongedEndTime, calcEndTime);

        let newPO = {
            "companyId": companyKey,
            "machineId": machineId,
            "itemNo": productId,
            "start": formatDateAndFullTime(startTime),
            "end": formatDateAndFullTime(prolongedEndTime),
            "plannedStartTime": formatDateAndFullTime(startTime),
            //"plannedEndTime": null, //"2025-10-01T11:11:11",
            "plannedEndTime": formatDateAndFullTime(prolongedEndTime),
            "plannedQty": quantity,
            "reportedQty": 0,
            "tool": tool,
            "machineName": machineName,
            "edit": props.edit === "true" ? true : false,
            "blockerDescription": "New",
            "idealCycleTime": idealCycleTime,
            "speedUnitTypeId": speedUnitTypeId,

            "OriginalPlannedStartTime": null,
            "OriginalPlannedEndTime": null,
            "OeeCalculationType": oeeType,
            "OeeValue": tak,
            "Comment": "No comment given" //###

        };

        //let replannedData = ReplanMachine2(newPO, machineData, machineName, gapInMinutes, props.snapToPrevious, props.replanOverlaps, props.recalculateAffectedOrders, companyKey); //    return {replannedOrder: updatePOData, replannedOrders: periods};
        let replannedData = ReplanMachine2(newPO, machineData, machineName, gapInMinutes, props.snapToPrevious, props.replanOverlaps, props.recalculateAffectedOrders, companyKey, props.scheduleRows, props.historicOeeData, defaultOee); //    return {replannedOrder: updatePOData, replannedOrders: periods};

        //console.log("Replanned data from function:", replannedData);

        //New order
        //console.log("Update moved PO:", replannedData.replannedOrder);
        replannedData.replannedOrder.edit = props.edit === "true" ? true : false;

        replannedData.replannedOrder.startTime = replannedData.replannedOrder.replannedStartTime;
        replannedData.replannedOrder.endTime = replannedData.replannedOrder.replannedEndTime;

        replannedData.OriginalPlannedStartTime = replannedData.replannedOrder.replannedStartTime;
        replannedData.OriginalPlannedEndTime = replannedData.replannedOrder.replannedEndTime;

        postNewPO(replannedData.replannedOrder).then((result) => {

            //console.log("PO created:", result);
            //console.log("MO No:", result?.data?.manufacturingOrder?.moNo || replannedData.replannedOrder.productionOrderNo);

            props.setShowBackdrop(false);
            setButtonDisabled(false);
            props.setOpenAddPopup(false);

            if (result.status) {
                pushNotification("Production order created "); // + (result?.data?.manufacturingOrder?.moNo || replannedData.replannedOrder.productionOrderNo));
            } else {
                pushErrorMessage("Could not create order: " + result?.message);
            }



            props.handleRefreshData();

        }).catch((error) => {
            console.log("Could not create order in the erp system", error);
            pushErrorMessage("Could not create order in the erp system", error);
            props.setShowBackdrop(false);
            setButtonDisabled(false);
        });


        //Update replanned orders
        replannedData.replannedOrders.forEach((period) => {

            //console.log("!!Update PO:", period);

            period.edit = props.edit === "true" ? true : false;

            if (period.id !== undefined && period.id !== null) {

                updatePO(period).then((result) => {

                    //console.log("PO updated:", result?.data?.manufacturingOrder?.moNo, result);

                    if (result.status) {
                        pushNotification("Production plan updated: " + result?.data?.manufacturingOrder?.moNo);
                    } else {
                        pushErrorMessage("Could not update plan: " + result?.message);
                    }

                }).catch((error) => {
                    console.log("Could not update plan in erp system", error);
                    pushErrorMessage("Could not update plan", error);
                    props.setShowBackdrop(false);
                });
            }
        });



    }

    const handleAddBlock = () => {

        //Validate inputs
        if (blockType === "") {
            pushErrorMessage("Please select a block type.");
            return;
        }
        if (blockEndTime <= startTime) {
            pushErrorMessage("End time must be after start time.");
            return;
        }

        props.setShowBackdrop(true);
        setButtonDisabled(true);

        let productId = "0";
        //startTime = new Date("2025-11-21T08:00:00");
        //let endTime = dayjs(startTime).add(30, 'hour').format(isoFormat);

        let quantity = "0";
        let tool = "123";
        let machineName = getMachineNameById(machineId);

        let newBlock = {
            "companyId": companyKey,
            "machineId": machineId,
            ProductionOrderId: "",
            "itemNo": productId,
            //"start": formatDateAndFullTime(startTime),
            //"end": formatDateAndFullTime(endTime),
            "plannedStartTime": formatDateAndFullTime(startTime),
            //"plannedEndTime": null, //"2025-10-01T11:11:11",
            "plannedEndTime": formatDateAndFullTime(blockEndTime),
            "plannedQty": quantity,
            "tool": tool,
            "machineName": machineName,
            "edit": props.edit === "true" ? true : false,
            "ProductionPlanBlockerId": blockType
        };

        //console.log("New block to create:", newBlock);

        postNewBlock(newBlock).then((result) => {

            //console.log("Block created:", result);

            props.setShowBackdrop(false);
            setButtonDisabled(false);
            props.setOpenAddPopup(false);

            if (result.status) {
                pushNotification("Block created!");
            } else {
                pushErrorMessage("Block not created: " + result?.message);
            }

            props.handleRefreshData();


        }).catch((error) => {
            console.log("Could not create block", error);
            pushErrorMessage("Could not create block", error);
            props.setShowBackdrop(false);
            setButtonDisabled(false);
        });
    }

    // Tab Panel component

    const StyledTab = styled((props) => <Tab disableRipple {...props} />)(

        ({ theme }) => ({

            textTransform: 'none',
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(20),
            marginRight: theme.spacing(0),
            minWidth: "150px",
            //backgroundColor: '#799c4a',
            color: 'rgba(255, 255, 255, 0.7)',
            '&.Mui-selected': {
                color: '#fff',
                backgroundColor: "#434957 !important",
            },
            '&.Mui-focusVisible': {
                backgroundColor: 'rgba(100, 95, 228, 0.32)',
            },
            '&.MuiTab-root': {
                backgroundColor: '#43495799',
                border: "1px solid #0c101b",
            },
        }),
    );

    const StyledTabs = styled((props) => (
        <Tabs
            {...props}
            TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
        />
    ))({
        '& .MuiTabs-indicator': {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'transparent',
        },
        '& .MuiTabs-indicatorSpan': {
            width: '100%',
            backgroundColor: '#fff',
        },
    });

    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    if (blockerQuery === undefined || blockerQuery.data === undefined || blockerQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (itemsForMachineQuery === undefined || itemsForMachineQuery.data === undefined || itemsForMachineQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (productionItemsQuery === undefined || productionItemsQuery.data === undefined || productionItemsQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }


    //console.log("props.operation:", props.operation);
    //console.log("productid:", productId);
    // console.log("Items for machine query data:", itemsForMachineQuery.data);
    // console.log("Current machine", machineId, getMachineNameById(machineId));
    // console.log("Item machines:", itemMachines);
    //console.log("current tool:", itemMachines.find(m => m.machineName === getMachineNameById(machineId))?.toolId);

    // console.log("Returning  startTime:", startTime, "quantity:", quantity, "itemOEE:", tak, "speedUnitTypeId:", speedUnitTypeId, "idealCycleTime:", idealCycleTime);

    // let result = ReCalculateEndTimeForNewOrder(startTime, quantity, 0, tak, speedUnitTypeId, idealCycleTime);
    // localCalcEndTime = result.calcEndTime;
    // localIidealTimeToEnd = result.idealTimeToEnd;
    // idealRunTime = result.idealRunTime;

    // console.log("oeeType", oeeType);

    return (
        <>
            {/* <AxionControls.AxionBackdrop open={showBackdrop} /> */}
            <Box sx={{ padding: 1, backgroundColor: colors.primary[600], height: '800px', borderRadius: 2, overflowY: "auto" }}>

                <Box sx={{ backgroundColor: colors.primary[400] }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: colors.primary[600] }}>
                        <StyledTabs value={selectedTab} onChange={handleTabChange} aria-label="styled tabs example">
                            <StyledTab label={formatMessage(messages.tabAddOrder)} {...a11yProps(0)} />
                            <StyledTab label={formatMessage(messages.tabAddBlocker)} {...a11yProps(1)} />
                        </StyledTabs>
                    </Box>



                    {selectedTab === 0 &&


                        <Box width="auto" sx={{ p: 1, m: 1, height: '715px', overflowY: "hidden", overflowX: "hidden" }} display="flex" flexDirection="column">

                            <Stack direction="row" spacing={0} alignItems="flex-start">
                                <Box >

                                    {/* <AxionControls.AxionAutocomplete
                                        sx={{ width: 300, marginLeft: 0, marginTop: 2 }}
                                        name="Product2"
                                        label="Product"
                                        multiple={false}
                                        value={productId}
                                        initialValue={productId}
                                        options={itemsForMachineQuery.data?.map((item, index) => ({
                                            id: item.itemNo,
                                            title: item.itemNo + " - " + item.itemName || "Besk. saknas",
                                        }))}
                                        onChange={(event, newValue) => handleProductChange(event, newValue)}
                                    /> */}
                                    {/* {!props?.machine?.la?.id &&
                                        <Box sx={{ width: "250px", marginLeft: 0, marginTop: 2 }}>
                                            <FormControl >
                                                <InputLabel id="machineLabel">Machine</InputLabel>
                                                <Select
                                                    name="InitMachine"
                                                    label="Machine"
                                                    sx={{ width: "250px" }}
                                                    width="250px"
                                                    disabled={false}
                                                    //initialValue={getMachineNameById(machineId) || ""}
                                                    value={getMachineNameById(initialMachineId) || ""}
                                                    onChange={handleInitialMachineChange}
                                                >
                                                    {props.machineQuery?.map((m) => (
                                                        <MenuItem key={m.id} value={m.machineName}>
                                                            {m.machineName}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    } */}

                                    {/* <Box sx={{ width: "250px", marginLeft: 0, marginTop: 2 }}>
                                        <FormControl >
                                            <InputLabel id="productLabel">{"Items for machine - " + getMachineNameById(machineId)}</InputLabel>
                                            <Select
                                                name="ProductForMachine"
                                                label={"Items for machine - " + getMachineNameById(machineId)}
                                                sx={{ width: "250px" }}
                                                width="250px"
                                                disabled={false}
                                                initialValue={productId || ""}
                                                value={productId || ""}
                                                onChange={(event, newValue) => handleProductChange(event, newValue)}
                                            >
                                                {distinctItemsForMachines?.filter(i => i.machineName === getMachineNameById(machineId))
                                                    .map((m, index) => (
                                                        <MenuItem key={index} value={m.itemNo}>
                                                            {m.itemNo} - {m.itemName}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Box> */}

                                    <Box sx={{ width: "280px", marginLeft: 0, marginTop: 1 }}>
                                        <FormControl >
                                            <AxionControls.AxionAutocomplete

                                                name="AllProducts"
                                                label={"All items"}
                                                multiple={false}
                                                width="280px"
                                                backgroundColor={colors.primary[400]}
                                                borderColor={colors.primary[400]}
                                                color={colors.primary[100]}
                                                curtainBgColor={colors.gray[800]}
                                                curtainTextColor={"#fff"}
                                                sx={{ mt: 1, mb: 1, width: "280px" }}
                                                //defaultValue={props.productionItems?.filter((item) => props.recurringSchedule?.itemId === item.id).map((item) => ({ id: item.id, title: item.name }))[0]}
                                                options={itemsForMachines}
                                                onChange={(event, newValue) => handleProductChange(event, newValue)}
                                            // onChange={(event, newValue, type) => {
                                            //     //props.recurringSchedule.multipleItemIds === true ? props.onChange({ target: { id: "itemIds", value: newValue?.map(v => v.id) } }) : props.onChange({ target: { id: "itemId", value: newValue?.id } });
                                            // }}
                                            />
                                        </FormControl>
                                    </Box>

                                    <Box sx={{ width: "280px", marginLeft: 0, marginTop: 2 }}>
                                        <FormControl >
                                            <InputLabel id="machineLabel">Machine</InputLabel>
                                            <Select
                                                name="Machine"
                                                label={formatMessage(messages.newPplLabelMachine)}
                                                sx={{ width: "280px" }}
                                                width="280px"
                                                disabled={false}
                                                initialValue={getMachineNameById(machineId) || ""}
                                                value={getMachineNameById(machineId) || ""}
                                                onChange={handleMachineChange}
                                            >
                                                {itemMachines?.map((m) => (
                                                    <MenuItem key={m.id} value={m.machineName}>
                                                        {m.abC_Class ? `${m.abC_Class} - ${m.machineName}` : m.machineName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>

                                    <Box sx={{ width: "280px", marginLeft: 0, marginTop: "25px" }}>
                                        <FormControl >
                                            <InputLabel id="oeeTypeLabel">OEE Type</InputLabel>
                                            <Select
                                                name="OeeType"
                                                label="OeeType"
                                                sx={{ width: "280px" }}
                                                width="280px"
                                                disabled={false}
                                                initialValue={"" || ""}
                                                value={oeeType || ""}
                                                onChange={(event, newValue) => handleOeeTypeChange(event, newValue)}
                                            >
                                                {oeeHistoric !== null &&
                                                    <MenuItem key={0} value={"historic"}>
                                                        {tak !== null ? `${(oeeHistoric * 100).toFixed(0)} %` : ""} - Latest OEE
                                                    </MenuItem>
                                                }
                                                {oeeAvg !== null &&
                                                    <MenuItem key={1} value={"historic avg"}>
                                                        {(oeeAvg * 100).toFixed(0)} % - Historic OEE Avg ({oeeAvgCount} POs)
                                                    </MenuItem>
                                                }
                                                <MenuItem key={2} value={"default"}>
                                                    {defaultOee !== null ? `${(defaultOee * 100).toFixed(0)} %` : ""} - Default OEE
                                                </MenuItem>
                                                <MenuItem key={3} value={"manual"}>
                                                    Manual OEE
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>

                                    <Box sx={{ width: "280px", marginLeft: "20px", marginTop: 2, height: "50px", display: "flex", alignItems: "center" }}>
                                        {showManualOeeInput && (
                                            <TextField
                                                name="ManualOee"
                                                label="Manual OEE %"
                                                value={manualOee !== null ? (manualOee * 100).toFixed(0) : ""}
                                                onChange={handleManualOeeChange}
                                            />
                                        )}
                                    </Box>

                                    {/* <Box sx={{ marginTop: 2 }}>Start time</Box> */}
                                    <Box sx={{ width: "280px", marginLeft: 0, marginTop: 2 }}>
                                        <GridDateTimePicker
                                            label={formatMessage(messages.newPplLabelStartDate)}
                                            labelTime={formatMessage(messages.newPplLabelStartTime)}
                                            locale={language}
                                            maxDate=""
                                            minDate={Date().toLocaleString()}
                                            onChange={handleStartTimeChange}
                                            onDirectChange={handleStartTimeChange}
                                            date={startTime}
                                            width="280px"
                                            sx={{ mt: 1, mb: 1, width: "280px", height: "150px" }}
                                        />
                                    </Box>

                                    <Box sx={{ width: "280px", marginLeft: 0 }}>
                                        <TextField
                                            name="quantity"
                                            label={"Quantity"}
                                            value={quantity}
                                            onChange={handleQuantityChange}
                                            sx={{ mt: 1, mb: 1, width: "280px" }}
                                        />  
                                    </Box>
                                </Box>

                                <Box height="100%">
                                    <Box
                                        sx={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(2, 1fr)",
                                            gap: 1,
                                            padding: "10px",
                                            marginTop: "16px",
                                            border: "1pt solid #666666"
                                        }}
                                    >
                                        {/* Align value box to the right */}
                                        <Box sx={{ width: "120px" }} ><FormattedMessage {...messages.newPplLabelHistoricOee} /></Box><Box sx={{ textAlign: "center", backgroundColor: historicOeeFound ? "#799c4a" : "#cc4a4a" }}>{historicOeeFound ? formatMessage(messages.newPplLabelYes) : formatMessage(messages.newPplLabelNo)}</Box>
                                        <Box sx={{ width: "120px" }}><FormattedMessage {...messages.newPplLabelOee} /></Box><Box sx={{ textAlign: "right" }}>{(tak * 100).toFixed(0)} %</Box>

                                        <Box sx={{ width: "120px" }}><FormattedMessage {...messages.newPplLabelToolId} /></Box><Box sx={{ textAlign: "right" }}>{toolId}</Box>
                                        <Box sx={{ width: "120px" }}><FormattedMessage {...messages.newPplLabelLastArticleForTool} /></Box><Box sx={{ textAlign: "right" }}>{lastArticleForTool || "-"}</Box>
                                        <Box sx={{ width: "120px" }}>Ideal cycle time</Box><Box sx={{ textAlign: "right" }}>{idealCycleTime.toFixed(2)} s</Box>

                                        <Box sx={{ width: "120px", marginTop: "10px" }}><FormattedMessage {...messages.newPplLabelStockBalance} /></Box><Box sx={{ textAlign: "right", marginTop: "10px" }}>{stockBalance}</Box>
                                        <Box sx={{ width: "120px" }}><FormattedMessage {...messages.newPplLabelReservedBalance} /></Box><Box sx={{ textAlign: "right" }}>{reservedBalance}</Box>
                                    </Box>
                                </Box>

                            </Stack>



                            <Box sx={{ width: 500, marginLeft: 0, marginTop: 2 }}>
                                <Stack display="flex" direction="row" alignContent="center" alignItems="center" spacing={1} >
                                    <Switch fontSize="small" onChange={handleSnapChange} checked={props.snapToPrevious === "true" ? true : false}
                                        sx={{

                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: "#799c4a !important",
                                                '&:hover': {
                                                    backgroundColor: alpha("#799c4a", theme.palette.action.hoverOpacity),
                                                },
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: "#799c4a !important",
                                            },
                                        }}
                                    />
                                    <Box><FormattedMessage {...messages.newPplLabelSwitchSnap} /></Box>
                                </Stack>
                                <Stack display="flex" direction="row" alignContent="center" alignItems="center" spacing={1}>
                                    <Switch fontSize="medium" onChange={handleReplanChange} checked={props.replanOverlaps === "true" ? true : false}
                                        sx={{

                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: "#799c4a !important",
                                                '&:hover': {
                                                    backgroundColor: alpha("#799c4a", theme.palette.action.hoverOpacity),
                                                },
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: "#799c4a !important",
                                            },
                                        }}
                                    />
                                    <Box><FormattedMessage {...messages.newPplLabelSwitchReplan} /></Box>
                                </Stack>
                                {/* <Stack display="flex" direction="row" alignContent="center" alignItems="center" spacing={1}>
                                    <Switch fontSize="medium" onChange={handleRecalculateChange} checked={props.recalculateAffectedOrders === "true" ? true : false}
                                        sx={{

                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: "#799c4a !important",
                                                '&:hover': {
                                                    backgroundColor: alpha("#799c4a", theme.palette.action.hoverOpacity),
                                                },
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: "#799c4a !important",
                                            },
                                        }}
                                    />
                                    <Box><FormattedMessage {...messages.newPplLabelSwitchRecalculate} /></Box>
                                </Stack> */}
                            </Box>
                            <Box sx={{ width: 500, marginLeft: 3, marginTop: 2, paddingTop: 1 }}>
                                <Stack display="flex" direction="row" alignContent="flex-end" alignItems="flex-end" spacing={1} height="20px">
                                    {props.replanOverlaps === "true" ?
                                        <>
                                            <Stack direction="row" spacing={1} alignItems="flex-start" justifyItems="flex-start" >
                                                <WarningAmberOutlinedIcon fontSize="medium" sx={{ width: "34px" }} />
                                                <Box marginLeft={1}><FormattedMessage {...messages.newPplLabelWarnOverlap} /></Box>
                                            </Stack>
                                        </>
                                        : <Box>  </Box>
                                    }
                                </Stack>



                            </Box>
                            {/* <Box sx={{ width: 500, marginLeft: 0, marginTop: 1 }}>
                                <Stack display="flex" direction="row" alignContent="center" alignItems="center" spacing={1}>
                                    <Switch fontSize="medium" onChange={handleAddBlockBeforeChange} checked={addBlockBefore === "true" ? true : false}
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: "#799c4a !important",
                                                '&:hover': {
                                                    backgroundColor: alpha("#799c4a", theme.palette.action.hoverOpacity),
                                                },
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: "#799c4a !important",
                                            },
                                        }}
                                    />
                                    <Box>Add blocked time span before order</Box>
                                </Stack>
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Box sx={{ width: 100, marginLeft: 0, }}>
                                        <AxionControls.AxionTextBox
                                            name="minutesBefore"
                                            label={"Minutes before"}
                                            value={minutesBefore}
                                            onChange={handleMinutesBeforeChange}
                                        />
                                    </Box>
                                    <Box>
                                        <AxionControls.AxionTextBox
                                            name="textBefore"
                                            label={"Text before"}
                                            value={blockTextBefore || ""}
                                            onChange={handleTextBeforeChange}
                                        />
                                    </Box>
                                </Stack>
                            </Box> */}
                            {/* <Box sx={{ width: 500, marginLeft: 0, marginTop: 1 }}>
                                <Stack display="flex" direction="row" alignContent="center" alignItems="center" spacing={1}>
                                    <Switch fontSize="medium" onChange={handleAddBlockAfterChange} checked={addBlockAfter === "true" ? true : false}
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: "#799c4a !important",
                                                '&:hover': {
                                                    backgroundColor: alpha("#799c4a", theme.palette.action.hoverOpacity),
                                                },
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: "#799c4a !important",
                                            },
                                        }}
                                    />
                                    <Box>Add blocked time span after order</Box>
                                </Stack>
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Box sx={{ width: 100, marginLeft: 0, }}>
                                        <AxionControls.AxionTextBox
                                            name="minutesAfter"
                                            label={"Minutes after"}
                                            value={minutesAfter}
                                            onChange={handleMinutesAfterChange}
                                        />
                                    </Box>
                                    <Box>
                                        <AxionControls.AxionTextBox
                                            name="textAfter"
                                            label={"Text after"}
                                            value={blockTextAfter || ""}
                                            onChange={handleTextAfterChange}
                                        />
                                    </Box>
                                </Stack>
                            </Box> */}

                            <Box sx={{ flexGrow: 1 }} />
                            <Stack direction="row" spacing={1} alignItems="center" justifyItems="center" marginTop={2}>
                                <>
                                    <Tooltip title={<Typography>
                                        Starttime: {dayjs(startTime).format(isoFormat)} <br />
                                        Idealcycletime: {idealCycleTime}<br />
                                        ItemOee: {tak}<br />
                                        PlannedQty: {quantity}<br />
                                        ReportedQty: - <br />
                                        Speedunittypeid: {speedUnitTypeId}<br />
                                        IdealTimeToEnd: {getHourAndMinutesFromMinutes(idealTimeToEnd).hours} h, {getHourAndMinutesFromMinutes(idealTimeToEnd).minutes} m<br />
                                        localCalcEndTime: {dayjs(calcEndTime).format(isoFormat)}<br />
                                        EndTime : {dayjs(startTime).add(idealTimeToEnd, 'minute').format(isoFormat)}<br />
                                        Calculation:<br />

                                        idealTimeToEnd_cycletime = {idealCycleTime} * {quantity} / {tak} / 60 = {idealCycleTime * quantity / tak / 60}  minutes<br />
                                        idealTimeToEnd_kg/h =  ({quantity} - {0}) / {idealCycleTime} * 60 / {tak} = {(quantity - 0) / idealCycleTime * 60 / tak}  minutes<br />
                                        OEE = {tak} %



                                    </Typography>} fontSize="medium"><InfoOutlinedIcon></InfoOutlinedIcon></Tooltip>
                                    <Box
                                        sx={{
                                            //display: "grid",
                                            //gridTemplateColumns: "repeat(1, 1fr)",
                                            gap: 1,
                                            padding: "10px",
                                            marginTop: "16px",
                                            border: "1pt solid #666666"
                                        }}
                                    >
                                        {/* Align value box to the right */}
                                        <Box sx={{ width: "300px" }} >{formatMessage(messages.newPplLabelIdealRuntime)}: {getHourAndMinutesFromMinutes(idealTimeToEnd).hours + " " + formatMessage(messages.newPplLabelHours) + ", " + getHourAndMinutesFromMinutes(idealTimeToEnd).minutes + " " + formatMessage(messages.newPplLabelMinutes)}</Box>
                                    </Box>
                                </>
                            </Stack>
                            <Button
                                disabled={buttonDisabled}
                                variant="contained"
                                sx={{
                                    marginTop: 2,
                                    marginLeft: "auto",
                                    display: "block",
                                    width: "140px",
                                }}
                                onClick={handleAddPO}>
                                {formatMessage(messages.btnAddOrder)}
                            </Button>
                        </Box>

                    }
                    {selectedTab === 1 &&

                        <Box width="auto" sx={{ p: 1, m: 1, height: '515px', overflowY: "auto" }} display="flex" flexDirection="column">
                            <FormControl >
                                <InputLabel id="machineLabelNew">Machine</InputLabel>
                                <Select
                                    name="Machine"
                                    label={formatMessage}
                                    sx={{ width: "300px" }}
                                    width="300px"
                                    disabled={false}
                                    initialValue={machineId || ""}
                                    value={machineId || ""}
                                    onChange={(event) => {
                                        setMachineId(event.target.value);
                                        //console.log("Selected machine:", event.target.value);
                                    }}

                                >
                                    {props.machineQuery?.map((m) => (
                                        <MenuItem key={m.id} value={m.id}>
                                            {m.machineName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Stack direction="row" width="100%" marginTop="15px" spacing={2}>

                                <Select
                                    name="BlockType"
                                    label={formatMessage(messages.newPplLabelBlocker)}
                                    sx={{ width: "300px", marginTop: 2 }}
                                    width="300px"
                                    disabled={false}
                                    initialValue={blockType || ""}
                                    value={blockType || ""}
                                    onChange={(event) => {
                                        setBlockType(event.target.value);
                                        //console.log("Selected blockType:", event.target.value);
                                    }}
                                >
                                    {blockerQuery?.data?.map((b) => (
                                        <MenuItem key={b.id} value={b.id}>
                                            <Stack direction="Row"> <Box sx={{ width: "35px", height: "15px", backgroundColor: b.color, borderRadius: "2px", marginRight: "7px" }} ></Box>
                                                {b.description}</Stack>
                                        </MenuItem>
                                    ))}
                                </Select>
                                <Button
                                    disabled={buttonDisabled}
                                    variant="contained"
                                    sx={{
                                        marginTop: "auto",
                                        marginLeft: "auto",
                                        display: "block",
                                        width: "140px",
                                    }}
                                    onClick={handleEditBlockers}>
                                    {formatMessage(messages.btnEditBlockers)}
                                </Button>

                            </Stack>

                            <Box sx={{ width: 300, marginLeft: 0, marginTop: 2 }}>
                                <GridDateTimePicker
                                    label={formatMessage(messages.newPplLabelStartDate)}
                                    labelTime={formatMessage(messages.newPplLabelStartTime)}
                                    locale={language}
                                    maxDate=""
                                    minDate={Date().toLocaleString()}
                                    onChange={handleStartTimeChange}
                                    onDirectChange={handleStartTimeChange}
                                    date={startTime}
                                    width="225px"
                                />
                            </Box>
                            <Box sx={{ width: 300, marginLeft: 0, marginTop: 2 }}>
                                <GridDateTimePicker
                                    label={formatMessage(messages.newPplLabelEndDate)}
                                    labelTime={formatMessage(messages.newPplLabelEndTime)}
                                    locale={language}
                                    maxDate=""
                                    minDate={Date().toLocaleString()}
                                    onChange={handleBlockEndTimeChange}
                                    onDirectChange={handleBlockEndTimeChange}
                                    date={blockEndTime}
                                    width="225px"
                                />
                            </Box>

                            <Box sx={{ flexGrow: 1 }} />
                            {/* Move button to bottom */}
                            <Button
                                disabled={buttonDisabled}
                                variant="contained"
                                sx={{
                                    marginTop: "auto",
                                    marginLeft: "auto",
                                    display: "block",
                                    width: "140px",
                                }}
                                onClick={handleAddBlock}>
                                {formatMessage(messages.btnAddBlocker)}
                            </Button>

                        </Box>
                    }



                </Box>
            </Box >

            <Popup
                width="300px"
                openPopup={showEditBlockers}
                setOpenPopup={setShowEditBlockers}
                maxWidth="sm"
                // title={<FormattedMessage {...messages.editStop} />}>
                title={"Update blockers"}
            >
                <ProductionPlanEditBlockers
                    setShowBackdrop={props.setShowBackdrop}
                    handleRefreshData={props.handleRefreshData}
                    setOpenPopup={setShowEditBlockers}
                />
            </Popup>
        </>

    );
}